import React, { useState } from 'react';
import { Box, Typography } from '@material-ui/core';
import { WizardButton } from './WizardButton';
import FieldInput from './FeildInput';

interface CustomizeJsonEditorProps {
    value: string;
    onChange: (val: string) => void;
    onJsonEntered?: (json: object) => void;
}

const CustomizeJsonEditor: React.FC<CustomizeJsonEditorProps> = ({
    value,
    onChange,
    onJsonEntered
}) => {
    const [error, setError] = useState('');

    function handleApply() {
        try {
            const parsed = JSON.parse(value);
            setError('');
            onJsonEntered?.(parsed);
        } catch {
            setError('Invalid JSON — please check your input.');
        }
    }

    return (
        <Box
            style={{
                borderRadius: 8,
                backgroundColor: '#f6f8fa',
                border: '1px dashed #b2dfd6',
                padding: 12,
                display: 'flex',
                flexDirection: 'column',
                gap: 12
            }}>
            <Typography style={{ fontSize: '0.82rem', color: '#888' }}>
                Paste a JSON below, or go back to previous step to generate one.
            </Typography>

            <FieldInput
                value={value}
                placeholder='{ "@context": [...], "credentialSubject": { ... } }'
                onChange={(v) => {
                    onChange(v);
                    setError('');
                }}
                multiline
                rows={21}
                style={{ width: '100%', height: '340px' }}
            />

            {error && (
                <Typography style={{ fontSize: '0.78rem', color: '#e24b4a' }}>{error}</Typography>
            )}

            <Box
                display="flex"
                alignItems="center"
                style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
                <WizardButton
                    variant="outlined"
                    onClick={handleApply}
                    disabled={!value.trim()}
                    style={{ fontSize: 12 }}>
                    Apply JSON
                </WizardButton>
            </Box>
        </Box>
    );
};

export default CustomizeJsonEditor;
